import React from "react";
import { ListItem } from "../core/pdf/types";

export interface ListItemState {
	item: ListItem,
	number: string,
}

export const ListItemContext = React.createContext<ListItemState | undefined>(undefined);

export function useListItem() {
	return React.useContext(ListItemContext);
}
